import { defineStore } from 'pinia'
import AccountService from '@/services/accountService'
import { channels } from '@/constants/Channel'
import { useAppStore } from '@/store/app'

export type RecipeDetail = {
  audienceCount: number
  createdCount: number
  activeCount: number
}

type Audiencestate = {
  recipesDetailsMap: Map<number, RecipeDetail>
  leadXOrganizationId: string
  leadXEmbedToken: string
  leadXBpseId: number
}

const useAudienceStore = defineStore('audience', {
  state: (): Audiencestate => ({
    recipesDetailsMap: new Map<number, RecipeDetail>([]),
    leadXOrganizationId: '',
    leadXEmbedToken: '',
    leadXBpseId: 0
  }),
  getters: {
    getRecipeDetail:
      state =>
      (segmentTemplateId: number): RecipeDetail | undefined => {
        return state.recipesDetailsMap.get(segmentTemplateId)
      },
    getLeadXOrganizationId: state => {
      return state.leadXOrganizationId
    },
    getLeadXEmbedToken: state => {
      return state.leadXEmbedToken
    }
  },
  actions: {
    setRecipeDetail(
      segmentTemplateId: number,
      recipeDetails: RecipeDetail
    ): void {
      this.recipesDetailsMap.set(segmentTemplateId, recipeDetails)
    },
    resetRecipeDetails(): void {
      this.recipesDetailsMap = new Map<number, RecipeDetail>([])
    },
    async fetchAndsetLeadXOrganizationId(): Promise<void> {
      const appstore = useAppStore()
      const accountService = new AccountService()

      if (appstore.getSelectedBusinessProfile) {
        const leadXOrganisationDetails = (
          await accountService.getAccountDetails(
            appstore.getSelectedBusinessProfile.id,
            channels.LeadX
          )
        )[0]
        if (leadXOrganisationDetails?.id) {
          this.leadXBpseId = leadXOrganisationDetails.id
        }
        if (leadXOrganisationDetails?.accountId) {
          this.leadXOrganizationId = leadXOrganisationDetails.accountId
        }
      }
    },
    async fetchAndSetLeadXEmbedToken(): Promise<void> {
      const appstore = useAppStore()
      const accountService = new AccountService()

      if (!this.leadXBpseId) {
        await this.fetchAndsetLeadXOrganizationId()
      }

      if (appstore.getSelectedBusinessProfile && this.leadXBpseId) {
        const leadXEmbedToken = await accountService.getEmbedAccessToken(
          appstore.getSelectedBusinessProfile.id,
          this.leadXBpseId
        )
        if (leadXEmbedToken) {
          this.leadXEmbedToken = leadXEmbedToken
        }
      }
    }
  }
})
export default useAudienceStore
